// Decommissioning of this legacy MyISA web app, see work item #537.
// Update these values when the schedule or the target url changes.
const MIGRATION = {
    newAppUrl: 'https://myisa.mintt.cloud',
    newAppHost: 'myisa.mintt.cloud',
    supportEmail: 'support@mintt.care',
    decommissionYear: 2026,
  };

export default MIGRATION;
